import { render, staticRenderFns } from "./JSONField.vue?vue&type=template&id=f251b578&lang=pug&"
import script from "./JSONField.vue?vue&type=script&lang=js&"
export * from "./JSONField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f251b578')) {
      api.createRecord('f251b578', component.options)
    } else {
      api.reload('f251b578', component.options)
    }
    module.hot.accept("./JSONField.vue?vue&type=template&id=f251b578&lang=pug&", function () {
      api.rerender('f251b578', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/fields/JSONField.vue"
export default component.exports